import { render, staticRenderFns } from "./HeaderLabel.vue?vue&type=template&id=4f05dac4&"
import script from "./HeaderLabel.vue?vue&type=script&lang=js&"
export * from "./HeaderLabel.vue?vue&type=script&lang=js&"
import style0 from "./HeaderLabel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports